import { Award, BadgeCheck, Calculator, QrCode, RotateCcw, Shield } from "lucide-react";
import { useStore } from "@/context/StoreContext";

/* The promises block: every line is drawn from a verifiable, settings-backed
   truth (admin-editable via settings.brand_promises). If a promise has not been
   committed to in settings, it does not render. Nothing is hardcoded here. */

const ICONS = { "badge-check": BadgeCheck, calculator: Calculator, "rotate-ccw": RotateCcw, "qr-code": QrCode, shield: Shield, award: Award };

export default function PromisesBlock() {
  const { config } = useStore();
  const promises = config?.brand_promises || [];
  if (!promises.length) return null;
  return (
    <section className="container-x mt-14" data-testid="promises-block">
      <p className="eyebrow text-center">THE SIYAARA PROMISE</p>
      <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {promises.map((p, i) => {
          const Icon = ICONS[p.icon] || BadgeCheck;
          return (
            <div key={p.title} className="border border-stone-200 bg-white p-4 text-center hover:border-gold transition-colors" data-testid={`promise-${i}`}>
              <Icon size={22} className="mx-auto text-gold" />
              <p className="font-heading text-sm font-semibold mt-2.5 leading-snug">{p.title}</p>
              <p className="text-[11px] text-stone-500 mt-1.5 leading-relaxed">{p.text}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
